export default "assets/images/icons/pin-e4cf0bf9.svg";